import _ from 'lodash'
import 'whatwg-fetch'
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { Alert, Table, Col, FormGroup, FormControl, Button, Panel, HelpBlock, Glyphicon } from "react-bootstrap";
  
class NetworkForm extends Component {

  constructor(props) {
    super(props);

    this.updateIPAddress = this.updateIPAddress.bind(this);
    this.updateData = this.updateData.bind(this);

    this.state = {
      "ipaddress": this.props.ipaddress,
    }

  }

  updateIPAddress(event) {
    this.setState({
      ipaddress: event.target.value,
    });
  }

  updateData(event) {
    event.preventDefault();
    this.props.onSubmit(this.state.ipaddress);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ipaddress: nextProps.ipaddress,
    })
  }

  render() {
    return (
      <Panel>
        <Panel.Heading>Network lookup</Panel.Heading>
        <Panel.Body>
        <form onSubmit={this.updateData}>
            <FormGroup>
              <Col sm={11}>
                <FormControl type="text" value={this.state.ipaddress} onChange={this.updateIPAddress} />
                <HelpBlock>Lookup details about the network of an IP address.</HelpBlock>
              </Col>
              <Col sm={1}>
                <Button type="submit" bsStyle="primary">Lookup</Button>
              </Col>
            </FormGroup>
          </form>
        </Panel.Body>
      </Panel>
    );
  }
}

class NetworkComponent extends Component {

  constructor(props) {
    super(props);
    
    this.update = this.update.bind(this);
    this.getURL = this.getURL.bind(this);
    this.checkResult = this.checkResult.bind(this);
    this.myRender = this.myRender.bind(this);

    this.state = {
      ipaddress: props.ipaddress,
      data: null,
      error: "",
    }

  }

  componentDidMount() {
    this.update();
  }

  componentDidUpdate() {
    if (this.state.ipaddress !== this.props.ipaddress) {
      this.setState({
        ipaddress: this.props.ipaddress,
        data: null,
        error: "",
      }, this.update);
    }
  }

  checkResult(res) {
    return Promise.resolve(res)
  }

  update() {

    let u = this.getURL();

    if (u == null) {

      this.setState({
        data: null,
        error: "Lookup not supported",
      });

      return

    }

    let checker = this.checkResult;

    fetch(u)
      .then((res) => res.json())
      .then((data) => {

        return new Promise((resolve, reject) => {

          if (data.status === "error") {
            
            if (data.messages.length > 0) {
              return reject(data.messages[0][1]);
            }
            
            return reject("unknown error");

          }

          checker(data.data).then(resolve).catch(reject);

        });

      })
      .then((data) => this.setState({
        data: data,
        error: "",
      })).catch((error) => this.setState({
        data: null,
        error: error,
      }));
          
  } 

  render() {

    if (this.state.error !== "") {
      return <Alert bsStyle="warning">{this.state.error}</Alert>
    }

    return this.myRender();

  }

}

class NetworkPrefix extends NetworkComponent {

  getURL() {

    let u = new URL("https://stat.ripe.net/data/prefix-overview/data.json")

    u.searchParams.append("max_related", "50");
    u.searchParams.append("resource", this.props.ipaddress);

    return u

  }

  myRender() {

    if (this.state.data == null) {
      return <div className="text-center text-muted"><Glyphicon glyph="flash" className="spinning" /> Loading...</div>;
    }

    return (
      <Table responsive>
        <thead>
          <tr>
            <th>Prefix</th>
            <th>ASN</th>
            <th>Block</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><tt>{this.state.data.resource}</tt></td>
            <td><tt>{this.state.data.asns[0].asn}</tt> <small className="text-muted">{this.state.data.asns[0].holder}</small></td>
            <td><tt>{this.state.data.block.resource}</tt> <small className="text-muted">{this.state.data.block.desc}</small></td>
          </tr>
        </tbody>
      </Table>
    );

  }

}

class NetworkWhois extends NetworkComponent {

  getURL() {

    let u = new URL("https://stat.ripe.net/data/whois/data.json");

    u.searchParams.append("resource", this.props.ipaddress);

    return u

  }

  checkResult(res) {
    return new Promise((resolve, reject) => {

      if (res.records.length === 0) {
        return reject("No records found");
      }

      return resolve(res);

    });
  }

  myRender() {

    if (this.state.data == null) {
      return <div className="text-center text-muted"><Glyphicon glyph="flash" className="spinning" /> Loading...</div>;
    }

    return <div>{this.state.data.records.map(
      (r) =>
        <Table responsive striped bordered>
          <tbody>
          {r.map((sr) => (
            <tr key={sr.key}>
              <td style={{width: "200px"}}><strong>{sr.key}</strong></td>
              <td>{sr.value}</td>
            </tr>
          ))}
          </tbody>
        </Table>
    )}</div>;

  }

}

class NetworkRouting extends NetworkComponent {

  getURL() {

    let u = new URL("https://stat.ripe.net/data/routing-status/data.json");

    u.searchParams.append("resource", this.props.ipaddress.split("/")[0]);

    return u

  }

  myRender() {

    if (this.state.data == null) {
      return <div className="text-center text-muted"><Glyphicon glyph="flash" className="spinning" /> Loading...</div>;
    }

    return (
      <Table responsive>
        <thead>
          <tr>
            <th>First seen in</th>
            <th>Last seen in</th>
            <th>Origins</th>
          </tr>
        </thead>
        <tbody>
          <tr>
           <td><tt>{this.state.data.first_seen.prefix}</tt> <small>From AS{this.state.data.first_seen.origin} at {this.state.data.first_seen.time}</small></td>
           <td><tt>{this.state.data.last_seen.prefix}</tt> <small>From AS{this.state.data.last_seen.origin} at {this.state.data.last_seen.time}</small></td>
           <td>{this.state.data.origins.map((o) => `AS${o.origin}`).join(", ")}</td>
          </tr>
        </tbody>
      </Table>
    );

  }

}

class NetworkReverseDNS extends NetworkComponent {

  getURL() {

    if (this.props.ipaddress.indexOf("/") > 0) {
      return null;
    }

    let u = new URL("https://stat.ripe.net/data/reverse-dns-ip/data.json");

    u.searchParams.append("resource", this.props.ipaddress);

    return u

  }

  checkResult(res) {
    return new Promise((resolve, reject) => {

      if (!res.result || res.result.length === 0) {
        return reject("No records found");
      }

      return resolve(res);

    });
  }

  myRender() {

    if (this.state.data == null) {
      return <div className="text-center text-muted"><Glyphicon glyph="flash" className="spinning" /> Loading...</div>;
    }

    return <tt>{this.state.data.result[0]}</tt>;

  }

}


class NetworkResult extends Component {
   
  render() {

    return (
      <div>
        <Panel>
          <Panel.Heading>Prefix details for <strong>{this.props.ipaddress}</strong></Panel.Heading>
          <Panel.Body>
            <NetworkPrefix ipaddress={this.props.ipaddress} />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>Whois details for <strong>{this.props.ipaddress}</strong></Panel.Heading>
          <Panel.Body>
            <NetworkWhois ipaddress={this.props.ipaddress} />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>Routing status for <strong>{this.props.ipaddress}</strong></Panel.Heading>
          <Panel.Body>
            <NetworkRouting ipaddress={this.props.ipaddress} />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>Reverse DNS for <strong>{this.props.ipaddress}</strong></Panel.Heading>
          <Panel.Body>
            <NetworkReverseDNS ipaddress={this.props.ipaddress} />
          </Panel.Body>
        </Panel>
      </div>
    );

  }
}

class BaseNetworkTool extends Component {
  
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      ipaddress: "ipaddress" in props.match.params ? props.match.params.ipaddress : "5.79.99.201",
    };

    if ("prefix" in props.match.params) {
      this.state.ipaddress += "/" + props.match.params.prefix
    }
   
  }

  componentDidUpdate() {

    let requestedIpaddress = _.get(this, "props.match.params.ipaddress", "5.79.99.201");

    if (requestedIpaddress === this.state.ipaddress) {
      return
    }

    // Reset state, this is a page change

    this.setState({
      ipaddress: requestedIpaddress,
    });

  }

  handleSubmit(ipaddress) {

    const ipAddressChanged = _.get(this, "props.match.params.ipaddress", "") !== ipaddress;

    if (ipAddressChanged) {
      this.props.history.push(`/network/${ipaddress}`);
    }

    this.setState({
      ipaddress: ipaddress,
    });

  }

  render() {
    return (
      <div>
        <NetworkForm ipaddress={this.state.ipaddress} onSubmit={this.handleSubmit} />
        <NetworkResult ipaddress={this.state.ipaddress} />
      </div>
    );
  }

}

const NetworkTool = withRouter(BaseNetworkTool);

export default NetworkTool;



// WEBPACK FOOTER //
// ./src/Network.js